import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'tvcore-search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss'],
    standalone: false
})
export class SearchInputComponent implements OnInit {
	@Input()
	PLACEHOLDER_LABEL: string;
	@Input()
	SEARCH_LABEL?: string;
	@Output()
	search: EventEmitter<string> = new EventEmitter<string>();

	control: FormControl;

	ngOnInit() {
		this.control = new FormControl();
	}

	emit() {
		const value = this.control.value;

		if (value) {
			this.search.emit(value);
			this.control.reset();
		}
	}
}
